<div class="rccc-modal">
  <!-- Header -->
  <div class="flex items-center justify-between px-5 py-4 border-b border-gray-200">
    <div class="flex items-center gap-2">
      <mat-icon style="color:#1C593D;">swap_horiz</mat-icon>
      <h2 class="text-lg font-bold text-gray-800">CLP → COP — Configuración</h2>
      <span class="ml-1 px-2 py-0.5 rounded-full text-xs font-bold"
        [class.bg-emerald-100]="form.activo" [class.text-emerald-700]="form.activo"
        [class.bg-gray-200]="!form.activo" [class.text-gray-500]="!form.activo">
        {{ form.activo ? 'Activo' : 'Inactivo' }}
      </span>
    </div>
    <button (click)="close()" class="text-gray-400 hover:text-gray-700"><mat-icon>close</mat-icon></button>
  </div>

  <div class="px-5 py-4 overflow-y-auto" style="max-height:75vh;">

    <div *ngIf="loading" class="text-sm text-gray-500 mb-3">Cargando…</div>
    <div *ngIf="error" class="mb-3 px-3 py-2 rounded-lg bg-red-50 border border-red-200 text-sm text-red-700">{{ error }}</div>
    <div *ngIf="okMsg" class="mb-3 px-3 py-2 rounded-lg bg-emerald-50 border border-emerald-200 text-sm text-emerald-700">✓ {{ okMsg }}</div>

    <p class="text-xs text-gray-500 mb-3">
      El cliente paga en <strong>CLP</strong> y recibe <strong>COP</strong> — ve <strong>una sola tasa COP/CLP</strong>.
      Internamente: CLP→USD (acá) y USD→COP por Vita (config “USD/COP”). El USD no se le muestra.
    </p>

    <!-- ALERTAS -->
    <div class="flex flex-col gap-2 mb-4">
      <div *ngIf="alertSinMargen" class="px-3 py-2 rounded-lg bg-red-50 border border-red-300 text-sm text-red-700">
        🔴 <strong>Sin margen en algún monto</strong> — ahí el cliente vería “servicio no disponible”. Revisá la config USD→COP.
      </div>
      <div *ngIf="alertBajoVita" class="px-3 py-2 rounded-lg bg-amber-50 border border-amber-300 text-sm text-amber-800">
        🟠 <strong>Damos menos que Vita</strong> en algún monto (piso de margen). El cliente recibiría menos que por Vita directo.
      </div>
      <div *ngIf="alertEspejoDegradado" class="px-3 py-2 rounded-lg bg-amber-50 border border-amber-300 text-sm text-amber-800">
        🟠 <strong>ESPEJO degradado</strong> — sin oferta retail viva de Vita; la pata USD→COP cayó a comisión propia.
      </div>
      <div *ngIf="alertFeedStale" class="px-3 py-2 rounded-lg bg-amber-50 border border-amber-200 text-sm text-amber-800">
        🟡 <strong>Tasa desactualizada</strong> — fallback (feed de Vita/fuente CLP caído). Reintentá en unos segundos.
      </div>
      <div *ngIf="!form.activo" class="px-3 py-2 rounded-lg bg-gray-100 border border-gray-300 text-sm text-gray-600">
        ⚪ CLP→COP está <strong>inactivo</strong>: el cliente no puede enviar. Activalo abajo cuando los números estén OK.
      </div>
    </div>

    <!-- Tasas: entrada CLP/USD + salida Vita COP/USD -->
    <div class="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-4">
      <!-- Entrada -->
      <div class="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
        <div style="background:linear-gradient(135deg,#eff6ff,#eef2ff);padding:10px 16px;border-bottom:2px solid #bfdbfe;">
          <h3 class="font-bold text-sm" style="color:#1d4ed8;">Entrada — CLP/USD</h3>
        </div>
        <div class="p-4 text-sm flex flex-col gap-2">
          <div class="flex justify-between"><span class="text-gray-400">Tasa usada ({{ sourceResuelta || '—' }})</span>
            <strong>{{ tasaClpUsd ? (tasaClpUsd | number:'1.2-2') : '—' }}</strong></div>
          <div class="flex justify-between text-xs text-gray-400"><span>Spot referencia</span>
            <span>{{ live?.spot ? (live!.spot | number:'1.2-2') : '—' }}</span></div>
          <div class="flex justify-between text-xs text-gray-400"><span>Venta Aguacate (vivo)</span>
            <span>{{ live?.liveSell ? (live!.liveSell | number:'1.2-2') : '—' }}</span></div>
          <div *ngIf="tasaStale" class="text-xs text-amber-600">⚠ tasa con fallback</div>
        </div>
      </div>
      <!-- Salida Vita -->
      <div class="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
        <div style="background:linear-gradient(135deg,#fef9c3,#fef3c7);padding:10px 16px;border-bottom:2px solid #fde68a;">
          <h3 class="font-bold text-sm" style="color:#a16207;">Salida — Vita COP/USD (actual)</h3>
        </div>
        <div class="p-4 text-sm flex flex-col gap-2">
          <div *ngFor="let rail of rails" class="flex justify-between">
            <span class="text-gray-400">{{ railLabel[rail] }}</span>
            <span>
              <strong>{{ vitaRetailCop(rail) ? (vitaRetailCop(rail) | number:'1.0-0') : '—' }}</strong>
              <span class="text-xs text-gray-400" *ngIf="vitaPartnerCop(rail)"> · costo {{ vitaPartnerCop(rail) | number:'1.0-0' }}</span>
            </span>
          </div>
          <div class="text-[11px] text-gray-400 mt-1">Retail = lo que Vita cobra a su cliente · costo = usd_sell partner.</div>
        </div>
      </div>
    </div>

    <!-- Form -->
    <div class="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden mb-4">
      <div style="background:linear-gradient(135deg,#f0fdf4,#ecfdf5);padding:10px 16px;border-bottom:2px solid #bbf7d0;">
        <h3 class="font-bold text-sm" style="color:#1e5a3f;">Configuración</h3>
      </div>
      <div class="p-4 flex flex-col gap-4">

        <div class="flex items-center justify-between gap-3">
          <span class="text-sm font-semibold"
            [class.text-gray-700]="usdCopOfrecido" [class.text-gray-400]="!usdCopOfrecido">
            Ofrecer CLP → COP al cliente
          </span>
          <button type="button" (click)="toggleActivo()" [disabled]="!usdCopOfrecido"
            [style.background]="form.activo ? '#1C593D' : '#cbd5e1'"
            [style.cursor]="usdCopOfrecido ? 'pointer' : 'not-allowed'"
            [style.opacity]="usdCopOfrecido ? 1 : 0.6"
            style="position:relative;width:52px;height:30px;border:none;border-radius:999px;flex-shrink:0;transition:background .2s;">
            <span [style.left]="form.activo ? '25px' : '3px'"
              style="position:absolute;top:3px;width:24px;height:24px;border-radius:50%;background:#fff;transition:left .2s;"></span>
          </button>
        </div>
        <!-- usd_cop es el master: sin USD→COP no se puede ofrecer CLP→COP. -->
        <div *ngIf="!usdCopOfrecido" class="px-3 py-2 rounded-lg bg-amber-50 border border-amber-200 text-xs text-amber-800 -mt-2">
          ⚠️ <strong>USD→COP está apagado.</strong> CLP→COP va por el puente USD→COP, así que primero tenés que activar USD→COP (en el modal "USD/COP") para poder ofrecer CLP→COP.
        </div>

        <div>
          <span class="block text-xs font-semibold text-gray-600 mb-2">Tasa CLP/USD que se le aplica al cliente</span>
          <div class="flex flex-col gap-2">
            <label *ngFor="let s of sources" class="flex items-start gap-3 p-3 rounded-xl border cursor-pointer"
              [class.border-blue-400]="form.tasaSource === s.value" [class.bg-blue-50]="form.tasaSource === s.value"
              [class.border-gray-200]="form.tasaSource !== s.value">
              <input type="radio" name="tasaSource" [value]="s.value" [(ngModel)]="form.tasaSource" (ngModelChange)="onFormChange()" class="mt-1" />
              <span class="flex-1">
                <span class="font-semibold text-sm text-gray-800">{{ s.label }}</span>
                <span class="block text-xs text-gray-500 mt-0.5">{{ s.hint }}</span>
                <span *ngIf="form.tasaSource === 'MANUAL' && s.value === 'MANUAL'" class="flex gap-3 mt-2 flex-wrap">
                  <label class="flex flex-col text-xs font-semibold text-gray-600 gap-1">Tasa CLP/USD
                    <input type="number" step="0.01" min="0" [(ngModel)]="form.tasaManual" (ngModelChange)="onFormChange()" name="tasaManual"
                      class="border border-gray-300 rounded-lg px-2 py-1.5 text-sm w-32" /></label>
                  <label class="flex flex-col text-xs font-semibold text-gray-600 gap-1">Vence
                    <input type="datetime-local" [(ngModel)]="form.tasaManualVigenteHasta" (ngModelChange)="onFormChange()" name="tasaManualHasta"
                      class="border border-gray-300 rounded-lg px-2 py-1.5 text-sm" /></label>
                </span>
              </span>
            </label>
          </div>
        </div>

        <div class="text-xs text-gray-500 bg-gray-50 rounded-lg px-3 py-2">
          <strong>Mínimo:</strong> 20 USD
          <span *ngIf="minClpEquivalente"> ≈ {{ minClpEquivalente | number:'1.0-0' }} CLP</span>
          <span class="text-gray-400">(igual que USD→COP; no editable).</span>
        </div>

        <label class="flex flex-col text-xs font-semibold text-gray-600 gap-1">
          Motivo del cambio (opcional)
          <input type="text" maxlength="200" [(ngModel)]="form.motivo" name="motivo"
            class="border border-gray-300 rounded-lg px-2 py-1.5 text-sm" />
        </label>
      </div>
    </div>

    <!-- Vista previa: lo que recibe el cliente -->
    <div class="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden mb-2">
      <div style="background:#f9fafb;padding:10px 16px;border-bottom:1px solid #e5e7eb;" class="flex items-center justify-between">
        <h3 class="font-bold text-sm text-gray-700">Lo que recibe el cliente</h3>
        <span *ngIf="previewLoading" class="text-xs text-gray-400">actualizando…</span>
      </div>
      <div class="p-3 overflow-x-auto">
        <div *ngFor="let rail of rails" class="mb-3">
          <div class="text-xs font-semibold text-gray-500 mb-1">{{ railLabel[rail] }}</div>
          <table class="w-full text-xs">
            <thead>
              <tr class="text-gray-400 text-left">
                <th class="py-1 pr-2">Paga (CLP)</th>
                <th class="py-1 pr-2">Recibe (COP)</th>
                <th class="py-1 pr-2" title="La única tasa que ve el cliente">Tasa cliente (COP/CLP)</th>
                <th class="py-1 pr-2">Ganancia USD</th>
                <th class="py-1 pr-2"></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let it of itemsDe(rail)" class="border-t border-gray-100"
                [class.opacity-50]="!it.cumpleMinimo || !it.disponible">
                <td class="py-1 pr-2 font-semibold">{{ it.montoClp | number:'1.0-0' }}</td>
                <td class="py-1 pr-2 font-semibold">{{ it.recibeCop | number:'1.0-0' }}</td>
                <td class="py-1 pr-2 font-bold" style="color:#1C593D;">{{ it.tasaEfectivaCopClp | number:'1.3-3' }}</td>
                <td class="py-1 pr-2" [class.text-red-600]="it.gananciaUsd <= 0" [class.text-emerald-700]="it.gananciaUsd > 0">
                  {{ it.gananciaUsd | number:'1.2-2' }}
                </td>
                <td class="py-1 pr-2 whitespace-nowrap">
                  <span *ngIf="!it.cumpleMinimo" class="text-amber-600" title="Bajo el mínimo de 20 USD">bajo mín.</span>
                  <span *ngIf="it.cumpleMinimo && !it.margenOk" class="text-red-600" title="Sin margen → no se ofrece">sin margen</span>
                  <span *ngIf="it.cumpleMinimo && it.margenOk && it.clamped" class="text-amber-600" title="No iguala a Vita por el piso de margen">&lt; Vita</span>
                </td>
              </tr>
              <tr *ngIf="itemsDe(rail).length === 0">
                <td colspan="5" class="py-2 text-gray-400">Sin tasa resoluble — revisá la fuente / el feed de Vita.</td>
              </tr>
            </tbody>
          </table>
        </div>
        <p class="text-[11px] text-gray-400 mt-1">
          La <strong>Tasa cliente (COP/CLP)</strong> es la única que ve el cliente. La pata USD→COP la espeja Vita (config “USD/COP”).
        </p>
      </div>
    </div>
  </div>

  <!-- Footer -->
  <div class="flex items-center justify-end gap-2 px-5 py-3 border-t border-gray-200">
    <button (click)="close()" class="px-4 py-2 rounded-lg text-sm font-semibold text-gray-600 hover:bg-gray-100">Cerrar</button>
    <button (click)="save()" [disabled]="saving || loading"
      class="px-4 py-2 rounded-lg text-sm font-bold text-white"
      style="background:#1C593D;" [style.opacity]="(saving || loading) ? 0.6 : 1">
      {{ saving ? 'Guardando…' : 'Guardar' }}
    </button>
  </div>
</div>
